// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__X4Ds_","feature":"Features_feature__1CBQx","featureHeading":"Features_featureHeading__3fiKD"};